import { cssSpacing } from "../../styles/index.js";
import { IconExclamationCircle } from "../Icon/icons/IconExclamationCircle/index.js";
import styled from "../../styled-components.js";
export var IconExclamationCircleForText = styled(IconExclamationCircle).attrs({
  size: 'small'
}).withConfig({
  displayName: "IconExclamationCircleForText",
  componentId: "sc-1lnefk5-0"
})(["block-size:1.25rem;margin-inline-end:", ";flex-shrink:0;"], cssSpacing('tighter-4', '4px'));